import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
import { computed, ref, watch } from "vue";
import ManualEntryStartDialog from "@/components/dashboard/ManualEntryStartDialog.vue";
import { stepRoute } from "@/models/intakeSteps";
import { useRequirementsStore } from "@/stores/requirementsStore";
export default /*@__PURE__*/ _defineComponent({
    __name: 'PaMnNotice',
    props: {
        order: {},
        readonly: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const requirementsStore = useRequirementsStore();
        const open = ref(false);
        const started = ref(null);
        watch(() => props.order.orderKey, () => (started.value = null));
        const mnOrderId = computed(() => props.order.mnOrderId || started.value);
        const renewable = computed(() => !props.readonly && props.order.status !== "Archived" && props.order.mnRenewable === true && !started.value);
        function onStarted(result) {
            started.value = result.intakeOrderId;
        }
        const shown = computed(() => requirementsStore.standaloneStarts.includes("mn") &&
            (Boolean(mnOrderId.value) ||
                (!props.readonly && props.order.status !== "Archived" && props.order.mnStartable === true)));
        return (_ctx, _cache) => {
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_alert = _resolveComponent("v-alert");
            return (shown.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_v_alert, {
                        type: "info",
                        variant: "tonal",
                        density: "compact",
                        class: "mb-4",
                        "data-testid": "pa-mn-notice"
                    }, {
                        append: _withCtx(() => [
                            (mnOrderId.value)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (renewable.value)
                                        ? (_openBlock(), _createBlock(_component_v_btn, {
                                            key: 0,
                                            variant: "text",
                                            color: "primary",
                                            "data-testid": "pa-mn-renew",
                                            onClick: _cache[0] || (_cache[0] = ($event) => (open.value = true))
                                        }, {
                                            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                                    _createTextVNode(" Renew MN ", -1)
                                                ]))]),
                                            _: 1
                                        }))
                                        : _createCommentVNode("", true),
                                    _createVNode(_component_v_btn, {
                                        to: _unref(stepRoute)('clinical_review', mnOrderId.value),
                                        variant: "text",
                                        color: "primary"
                                    }, {
                                        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                                _createTextVNode("Open MN", -1)
                                            ]))]),
                                        _: 1
                                    }, 8, ["to"])
                                ], 64))
                                : (_openBlock(), _createBlock(_component_v_btn, {
                                    key: 1,
                                    variant: "text",
                                    color: "primary",
                                    onClick: _cache[1] || (_cache[1] = ($event) => (open.value = true))
                                }, {
                                    default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                            _createTextVNode("Start MN on this PA", -1)
                                        ]))]),
                                    _: 1
                                }))
                        ]),
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(mnOrderId.value ? "This PA has its medical necessity order." : "Run medical necessity on this PA, no fax needed.") + " ", 1)
                        ]),
                        _: 1
                    }),
                    _createVNode(ManualEntryStartDialog, {
                        modelValue: open.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((open).value = $event)),
                        step: "mn_on_pa",
                        "order-key": __props.order.orderKey,
                        onStarted: onStarted
                    }, null, 8, ["modelValue", "order-key"])
                ], 64))
                : _createCommentVNode("", true);
        };
    }
});
